<template>
  <div
    class="d-inline-flex flex-wrap align-center"
    style="gap: 6px;"
    :class="cssClass"
  >
    <v-chip
      small
      class="text-uppercase"
      :class="{
        'green white--text': subscription.data.status === SUBSCRIPTION_STATUS_ACTIVE,
        'red white--text': subscription.data.status === SUBSCRIPTION_STATUS_CANCELED
      }"
    >
      {{ $t(`SubscriptionStatus.${subscription.data.status}`) }}
    </v-chip>

    <v-tooltip v-if="showCancelOption" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          small
          color="warning"
          text-color="white"
          class="text-uppercase"
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('Cancels', {date: fullDateFormat(subscription.data.current_billing_period.ends_at)}) }}
        </v-chip>
      </template>
      <span>{{ $t('subsciption_cancels_tooltip') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { fullDateFormat } from '@/components/calendar/config';
import SubscriptionsMixin from '@/lib/SubscriptionsMixin';

export default {
  mixins: [SubscriptionsMixin],
  props: {
    subscription: {
      type: Object,
      required: true,
    },
    showCancelOption: {
      type: Boolean,
      default: false,
    },
    cssClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    fullDateFormat,
  },
};
</script>
